import { tt } from "../../../utils/i18n/i18n";
import React from "react";
import BillStatus from "@tootsweet/model/entities/enum/BillStatus";
import billStatus from "@tootsweet/model/entities/enum/BillStatus";
import "../styles.scss";

import KC_Span from "../../../designsystem/KC_Span/KC_Span";
import KC_Colors from "../../../designsystem/KC_Colors";

interface BillStatusSwitchI {
  status: BillStatus;
}

export default function BillStatusSwitch({ status }: BillStatusSwitchI) {
  switch (status) {
    case BillStatus.Paid: {
      return (
        <KC_Span
          isBold
          text={tt("paid")}
          className="text-center"
          color={KC_Colors.Green_two}
        />
      );
    }
    case billStatus.Pending:
    case billStatus.Discounted:
    case billStatus.PaymentFailed: {
      return (
        <KC_Span
          isBold
          text={tt("to_pay")}
          className="text-center"
          color={KC_Colors.Error}
        />
      );
    }
    case billStatus.Canceled: {
      return (
        <KC_Span
          isBold
          text={tt("canceled")}
          className="text-center"
          color={KC_Colors.Blue}
        />
      );
    }
    case billStatus.Refunded: {
      return (
        <KC_Span
          isBold
          text={tt("refunded")}
          className="text-center"
          color={KC_Colors.Blue}
        />
      );
    }
    case billStatus.AwaitingPaymentConfirmation: {
      return (
        <KC_Span
          isBold
          className="text-center"
          text={tt("payment_in_progress")}
          color={KC_Colors.Red}
        />
      );
    }
    default:
      return <>--</>;
  }
}
